var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconElectoralWizard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wizard_eleitoral"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M98.0009 13.7498C97.3758 20.1237 99.3739 26.5005 103.75 31.1246C97.3758 31.5014 91.4985 34.6242 87.6251 39.7507C88.2502 33.374 86.2492 27 81.8762 22.3758C88.2502 21.8763 94.1246 18.7507 98.0009 13.7498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M59.3748 17.2493C58.7497 25.3758 61.2501 32.8744 66.2511 38.0009C59.1236 38.2493 51.999 42 46.8753 48.2511C47.5004 40.2502 45 32.6261 39.999 27.4995C47.1237 27.2512 54.2511 23.5005 59.3748 17.2493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M96.999 48.9991C96.4995 53.5005 98.0009 57.8763 101.001 61.2502C96.4995 61.5014 92.3749 63.7507 89.6261 67.2503C90.1256 62.7489 88.6241 58.3758 85.6241 54.9991C90.1255 54.7507 94.2502 52.4986 96.999 48.9991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.8177 99.8651L60.6307 55.0521L67.7023 62.1237L22.8894 106.934L15.8177 99.8651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M64.1554 51.6419L75.2037 40.5935L82.2753 47.6623L71.227 58.7107L64.1554 51.6419Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectoralWizard);
export default __webpack_public_path__ + "static/media/icon-electoral-wizard.f3bcbe51246853f49b2b2bcb31fde1b6.svg";
export { ForwardRef as ReactComponent };